import React, { useEffect, useState } from 'react';

import { getEnv } from '@config';
import { usePromotions, useScript } from '@hooks';
import styled, { css } from 'styled-components';
import { Box, Button, Icon } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import { FinancialProduct } from '@components/FinancialProducts';
import { AppLoader } from '@components/AppLoader';
// eslint-disable-next-line import/no-named-as-default
import FalabellaSellerCredits from './Widgets/FalabellaSellersCredits';
// eslint-disable-next-line import/no-named-as-default
import FalabellaSellerCl from './Widgets/FalabellaSellerCl';
import FalabellaSellerCA from './Widgets/FalabellaSellerCA';

const { publicPath } = getEnv();
export const HOME = `${publicPath}`;

const Layout = styled.div(
  () => css`
    display: flex;
    justify-content: center;
    background-color: #f8f8f8;
  `
);

const StyledDiv = styled.div(
  () => css`
    width: 504px;
    height: 488px;
    flex-grow: 0;
    padding: 80px 89.7px 72px 90.7px;
    border-radius: 6px;
    background-color: #fff;
  `
);

const StyledTitle = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['H5-w400']}
    text-align: center;
    margin-top: 37.7px;
    margin-bottom: 16px;
  `
);

const StyledMessage = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Subtitle-1-w500']}
    text-align: center;
    color: ${theme.colors.gray700};
  `
);

const StyledOkButton = styled.div(
  () => css`
    display: flex;
    justify-content: center;
    margin: 30px 81.6px 0 80.6px;
  `
);

const StyledIcon = styled(Icon)`
  width: 96.4px;
  height: 96.4px;
  display: block;
  margin: auto;
`;

const buttonCallback = () => {
  window.history.go(-1);
};

const financialProductsMap = new Map([
  ['NO_PROMOTIONS', 'NO_PRODUCTS_AVAILABLE'],
  ['CREDIT_FACILITY', 'CREDIT_FACILITY_AVAILABLE'],
  ['CHECKING_CREDIT', 'CHECKING_CREDIT_AVAILABLE'],
  ['CHECKING_CREDIT_WITH_ACCOUNT', 'CHECKING_CREDIT_WITH_ACCOUNT_AVAILABLE'],
  ['MULTIPLE_PRODUCTS', 'CREDIT_FACILITY_AND_CHECKING_CREDIT_AVAILABLE'],
]);

const SellerCreditFacility = () => {
  useScript(`${publicPath}/scripts/tracking.js`);
  const [financingOptions, setFinancingOptions] = useState(
    financialProductsMap.get('NO_PROMOTIONS')
  );
  const { t } = useTranslation();

  const { isPromotionsLoading, getPromotions, promotionEnablesWidget, promotions } =
    usePromotions();
  const financingProductsComponent = () => {
    const isCreditFacility = promotions.some(
      (e) => e.product === 'CREDIT_FACILITY' && !(e.state === 'REJECTED')
    );
    const isCheckingCredit = promotions.some(
      (e) => e.product === 'CHECKING_CREDIT' && !(e.state === 'REJECTED')
    );
    const isCheckingCreditWithAccount = promotions.some(
      (e) => e.product === 'CHECKING_CREDIT_WITH_ACCOUNT' && !(e.state === 'REJECTED')
    );
    if (isCreditFacility && isCheckingCredit)
      setFinancingOptions(financialProductsMap.get('MULTIPLE_PRODUCTS'));
    else if (isCheckingCredit) setFinancingOptions(financialProductsMap.get('CHECKING_CREDIT'));
    else if (isCreditFacility) setFinancingOptions(financialProductsMap.get('CREDIT_FACILITY'));
    else if (isCheckingCreditWithAccount)
      setFinancingOptions(financialProductsMap.get('CHECKING_CREDIT_WITH_ACCOUNT'));
  };

  useEffect(() => {
    getPromotions();
  }, [getPromotions]);

  useEffect(() => {
    financingProductsComponent();
  }, [promotions]);

  return (
    <>
      {isPromotionsLoading ? (
        <AppLoader />
      ) : (
        <>
          {promotionEnablesWidget() ? (
            (financingOptions === 'CREDIT_FACILITY_AND_CHECKING_CREDIT_AVAILABLE' && (
              <FinancialProduct
                financialOptionsAction={(value) => setFinancingOptions(value)}
                promotionsArray={promotions}
              />
            )) ||
            (financingOptions === 'CHECKING_CREDIT_AVAILABLE' && <FalabellaSellerCredits />) ||
            (financingOptions === 'CHECKING_CREDIT_WITH_ACCOUNT_AVAILABLE' && (
              <FalabellaSellerCA />
            )) ||
            (financingOptions === 'CREDIT_FACILITY_AVAILABLE' && <FalabellaSellerCl />)
          ) : (
            <Layout>
              <Box>
                <StyledDiv>
                  <StyledIcon icon="ic-smile" color="gray600" />
                  <StyledTitle>{t('finance.noPromotions.title')}</StyledTitle>
                  <StyledMessage>{t('finance.noPromotions.message')}</StyledMessage>
                  <StyledOkButton>
                    <Button
                      size="medium"
                      id="financing-not-found-btn"
                      data-testId="finance-noPromotions-testId"
                      onClick={buttonCallback}
                    >
                      {t('finance.noPromotions.textButton')}
                    </Button>
                  </StyledOkButton>
                </StyledDiv>
              </Box>
            </Layout>
          )}
        </>
      )}
    </>
  );
};
export default SellerCreditFacility;
